module.exports = __webpack_public_path__ + "static/img/Clayton-Oliver.a3290bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clayton-Oliver.jpg
// module id = Cd8a
// module chunks = 0